import type { SugarmateError } from "@tandemdiabetes/sugarmate-api-react-client"
import { Toast } from "@tandemdiabetes/sugarmate-react-components"
import { useMemo } from "react"
import { usePolyglot } from "src/contexts"

interface Props {
  id: string;
  status?: SugarmateError["status"];
  code?: SugarmateError["code"];
}

const polyglotPrefix = "toasts.sign_up_error."

export function SignUpErrorToast(props: Props) {
  const {
    id,
    code = null,
    status: responseStatus,
  } = props

  const polyglot = usePolyglot()
  const body = useMemo(
    () => {
      switch (code) {
        case 1010: // account already exists
          return polyglot.t(`${polyglotPrefix}duplicate_account`)
        case 1011: // unsupported country
          return polyglot.t(`${polyglotPrefix}unsupported_country_body`)
        case 1012: // invalid password
          return polyglot.t("error_messaging.password_invalid")
        case 1013: // invalid email
          return polyglot.t(`${polyglotPrefix}invalid_email_body`)
        default:
          // missing fields
          if (responseStatus === 400) {
            return polyglot.t("error_messaging.missing_fields")
          }

          return polyglot.t("error_messaging.generic_error")
      }
    },
    [
      code,
      responseStatus,
      polyglot,
    ],
  )

  return (
    <Toast
      stylePreset="error"
      body={body}
      id={id}
    />
  )
}
